
import { isResponseForGrouping, iterateGroups, getColumnParamsByDataField, iterateOverFilters } from './utils'

const ONE_DAY = 1000 * 60 * 60 * 24;

export default {
  middlewareForRequest: ({ loadOptions }) => {
    loadOptions.group = iterateGroups(loadOptions.group, group => ({
      ...group,
      selector: getColumnParamsByDataField(group.selector).keyForRequest,
    }))

    /* transform startDate group key to date in milliseconds */
    loadOptions.filter = iterateOverFilters(loadOptions.filter, ([paramKeys, logicalOperator, filterValue]) => {
      if (paramKeys === 'startDate' && typeof filterValue === 'string') {
        const isUTC0 = filterValue[filterValue.length - 1] === 'Z'
        if (isUTC0) filterValue = filterValue.slice(0, -1)
        return ['startDate', logicalOperator, +new Date(filterValue)]
      }
      return [paramKeys, logicalOperator, filterValue]
    })
    loadOptions.filter = iterateOverFilters(loadOptions.filter, ([paramKeys, logicalOperator, filterValue]) => {
      if (paramKeys === 'startDate' && logicalOperator === '=') {
        return [['startDate', '>=', +new Date(filterValue)], 'and', ['startDate', '<', +new Date(filterValue) + ONE_DAY]]
      }
      return [paramKeys, logicalOperator, filterValue]
    })

    return loadOptions
  },

  middlewareForResponse: ({ transcripts }) => {
    if (!isResponseForGrouping(transcripts)) return transcripts
    return replaceTranscriptsToItems(transcripts)
  },
}

function replaceTranscriptsToItems(data) {
  return data.map(transcript => {
    if (transcript.transcripts !== undefined) transcript.items = transcript.transcripts
    if (!transcript.items) {
      transcript.items = null
    } else {
      transcript.items = replaceTranscriptsToItems(transcript.items)
    }
    return transcript
  })
}
